import {
  constructTeam,
  constructTeams
} from './helpers';

export const STORE_TEAMS = 'teams/STORE_TEAMS';
export const UPDATE_TEAM = 'teams/UPDATE_TEAM';

function storeTeams(teams) {
  return {
    type: STORE_TEAMS,
    payload: {
      teams: constructTeams(teams)
    }
  };
}

export function updateTeam(team) {
  return {
    type: UPDATE_TEAM,
    payload: {
      team: constructTeam(team)
    }
  };
}


export function fetchTeams(sparkInstance) {
  return (dispatch) =>
    sparkInstance.internal.team.list()
      .then((teams) => {
        if (teams && teams.length) {
          dispatch(storeTeams(teams));

          return Promise.resolve(teams);
        }

        return Promise.resolve();
      })
      .catch((e) => Promise.reject(new Error('Could not fetch teams', e)));
}
